import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";
import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import classes from "./classes.module.scss";

export type BlockContentProps = {
	primaryText: string;
	secondaryText?: string;
	tertiaryText?: string;
	statusBadge?: string;
	showAlert: boolean;
	hasSeparator: boolean;
	isActive: boolean;
	badgeThemeKey: "archived" | "deleted" | "invited" | "default";
};

export function getBlockBadgeThemeKey(statusBadge: string | undefined): "archived" | "deleted" | "invited" | "default" {
	switch (statusBadge) {
		case "Archivé":
			return "archived";
		case "Supprimé":
			return "deleted";
		case "Invité":
			return "invited";
		default:
			return "default";
	}
}

function renderBlockTextContent(props: BlockContentProps): React.JSX.Element {
	const { primaryText, secondaryText, tertiaryText, statusBadge, isActive, badgeThemeKey } = props;
	return (
		<div className={classes["text-container"]}>
			<div className={classes["secondary-line"]}>
				<Typography typo={ETypo.TEXT_MD_LIGHT} color={ETypoColor.NAVIGATION_BUTTON_CONTRAST_DEFAULT}>
					{secondaryText}
				</Typography>
				{statusBadge && (
					<span className={classes["status-badge"]} data-theme={badgeThemeKey}>
						{statusBadge}
					</span>
				)}
			</div>
			<Typography
				typo={ETypo.TEXT_MD_BOLD}
				color={isActive ? ETypoColor.NAVIGATION_BUTTON_CONTRAST_ACTIVE : ETypoColor.NAVIGATION_BUTTON_CONTRAST_DEFAULT}>
				{primaryText}
			</Typography>
			{tertiaryText && (
				<Typography typo={ETypo.TEXT_SM_LIGHT} color={ETypoColor.TEXT_SECONDARY}>
					{tertiaryText}
				</Typography>
			)}
		</div>
	);
}

type BlockBodyProps = {
	contentProps: BlockContentProps;
};

export function BlockBody(props: BlockBodyProps): React.JSX.Element {
	const { contentProps } = props;
	const { showAlert, hasSeparator } = contentProps;
	return (
		<>
			<div className={classes["content"]}>
				{renderBlockTextContent(contentProps)}
				{showAlert && (
					<ExclamationCircleIcon width="24" height="24" className={classes["icon"]} color={"var(--warning-default-base)"} />
				)}
				<ChevronRightIcon width="24" height="24" className={classes["icon"]} color={"var(--button-icon-button-default-default)"} />
			</div>
			{hasSeparator && <div className={classes["separator"]} />}
		</>
	);
}
